module.exports = __webpack_public_path__ + "img/newCand-f2f-icon.4f47bb63.svg";